import { lazy, Suspense, useMemo } from 'react'

import PageLoader from '@/components/PageLoader'

import { getPaymentReturnUrl, PAY_MODULE_REFERRER_KEY } from '@/app/pages/pay/utils'

const PayModule = lazy(() =>
  import('@paysense-india-services/pay-module').then(m => ({ default: m.PayModule }))
)

const THEMES = {
  payufin: {
    colors: {
      'brand-color': '#0ABF89',
      'brand-light-color': '#dfebfe',
      'brand-dark-color': '#00AD7D'
    },
    fontFamily: "'Plus Jakarta Sans', sans-serif"
  }
}

const DEFAULT_THEME = THEMES.payufin

const PaymentPage = () => {
  // Referrer is set by the parent page in sessionStorage before navigation
  // (avoids URL bloat from long referrer URLs).
  const referrer = useMemo(() => {
    if (typeof window === 'undefined') return null
    try {
      const encoded = sessionStorage.getItem(PAY_MODULE_REFERRER_KEY)
      return encoded ? decodeURIComponent(encoded) : getPaymentReturnUrl()
    } catch {
      return getPaymentReturnUrl()
    }
  }, [])

  const config = useMemo(
    () => ({
      environment: import.meta.env.VITE_ENV === 'production' ? 'production' : 'sandbox',
      referrer
    }),
    [referrer]
  )

  return (
    <Suspense fallback={<PageLoader isLoading={true} />}>
      <PayModule config={config} theme={DEFAULT_THEME} />
    </Suspense>
  )
}

export default PaymentPage
